import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import { Doughnut } from "react-chartjs-2";

ChartJS.register(ArcElement, Tooltip, Legend);

ChartJS.defaults.font.family = "Nunito";
ChartJS.defaults.font.size = 10;

const DoughnutChart = ({ value, confiq }) => {
  /*  console.log(value);  */ /* array of two arrays */
  let dataLabel = value[0];
  let dataValue = value[1];

  const data = {
    labels: dataLabel,
    datasets: [
      {
        label: "Quantity",
        data: dataValue,
        hoverBackgroundColor: ["rgba(54, 163, 235, 0.6)", "rgba(255, 206, 86, 0.5)", "rgba(255, 99, 133, 0.65)"],
        /*   borderColor: [
                          'rgba(255, 99, 132, 1)',
                          'rgba(54, 162, 235, 1)',
                          'rgba(255, 206, 86, 1)',
                          'rgba(75, 192, 192, 1)',
                          'rgba(153, 102, 255, 1)',
                          'rgba(255, 159, 64, 1)',
                    ], */
        borderWidth: 1,
        cutout: 30,
        borderRadius: 4,
        backgroundColor: ["rgba(54, 162, 235, 0.9)", "rgba(255, 206, 86, 0.9)", "rgba(250, 47, 74, 0.87)"],
        /* hoverBackgroundColor: ["rgba(255, 206, 86, 0.9)", "rgba(54, 162, 235, 0.9)", "rgba(255, 99, 132, 0.9)"], */
      },
    ],
  };

  const options = {
    plugins: {
      legend: {
        position: "top",
        align: "center",
        labels: {
          boxWidth: 8,
        },
      },
      title: {
        display: true,
        text: confiq.title,
      },
    },
  };
  return (
    <div className='DoughnutChart'>
      <Doughnut data={data} options={options} />
    </div>
  );
};

export default DoughnutChart;
